/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './EligibilityQuestionFishingTruck.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import BackAnchor from '../../../../shared/components/BackAnchor'
const EligibilityQuestionFishingTruckView = ({ t, i18n }) => {
  const history = useHistory()

  const { masterNumber, plateNumber, vinSerialNumber, vehicleType } = useSelector((state) => state.app)

  useEffect(() => {
    try {
      if (masterNumber === '' || plateNumber === '' || vinSerialNumber === '' || vehicleType !== 'fisherman') {
        history.push(`/${i18n.language}${t('routes.your_info')}`)
      }
    }
    catch (err) {
      console.log(err)
    }
  }, [])


  const handleYes = () => {
    history.push(`/${i18n.language}${t('routes.fishing_licence_info')}`)
  }

  const handleNo = () => {
    history.push(`/${i18n.language}${t('routes.not_eligible_fishing')}`)
  }

  const motorVehicleAct = useMemo(() => {
    return i18n.language === "en" ? t('eligibility_question_farm.motor_vehicle_act') : <i>{t('eligibility_question_farm.motor_vehicle_act')}</i>
  }, [i18n.language])

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <BackAnchor />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{t('title')}</h1>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h3>{t('eligibility_question_fishing.do_you_continue')}<a
            target="_blank"
            rel="noopener noreferrer"
            href='https://www.novascotia.ca/just/regulations/regs/fcraqualiclease.htm'
            hrefLang={i18n.language === "fr" ? "en" : undefined}
          >
            {t('eligibility_question_fishing.eligibility_requirements')}
            <span className="ns-visually-hidden">{t('shared.opens_new_tab')}</span>
          </a>{t('eligibility_question_fishing.under_the')}{motorVehicleAct}{t('eligibility_question_fishing.under_the_cont')}</h3>
          <p>{t('eligibility_question_fishing.help_text')}</p>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <button className={'btn-lg btn-default'} onClick={handleYes} value={t('eligibility_question_fishing.yes')} name={t('eligibility_question_fishing.yes')}>
            {t('eligibility_question_fishing.yes')}
          </button>
          <button
            className={['btn-lg btn-default', styles['margin_left_20']].join(' ')}
            onClick={handleNo}
            value={t('eligibility_question_fishing.no')}
            name={t('eligibility_question_fishing.no')}
          >
            {t('eligibility_question_fishing.no')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(EligibilityQuestionFishingTruckView)
